import React, { useEffect, useState } from "react";
import { MultiSelect } from "react-multi-select-component";
import {
    bodyShapeArray,
    downplayArray,
    heightArray,
    occasionArray,
    paletteOptions,
    styleIdentityArray,
} from "utils/staticData";
import { Star } from "utils/text";
import Select from "react-select";
import { color } from "@mui/system";
import {
    masterBrandListApi,
    masterClothingCategoriesListApi,
    masterColorApi,
    masterSizeApi,
} from "services/master";
import { toastMessage } from "utils/toastMessage";

const CommonForm = ({ selectedOptions = [], setSelectedOptions = () => { }, errors, setErrors }) => {
    const [categoryList, setCategoryList] = useState([]);
    const [brandList, setBrandList] = useState([]);
    const [colorList, setColorList] = useState([]);
    const [showSize, setShowSize] = useState(false);
    const [sizeType, setSizeType] = useState("");
    const [sizeList, setSizeList] = useState([]);

    //-----------handle-height-------------------
    const handleHeightChange = (selected) => {
        setSelectedOptions((prev) => ({ ...prev, height: selected || [] }));
        setErrors((prevData) => ({ ...prevData, height: null }));
    };
    //-----------handle-Palette-Options-------------------
    const handlePaletteOptions = (selected) => {
        setSelectedOptions((prev) => ({ ...prev, paletteName: selected || [] }));
        setErrors((prevData) => ({ ...prevData, paletteName: null }));
    };
    //-----------handle-Body-Shape-Change-------------------
    const handleBodyShapeChange = (selected) => {
        setSelectedOptions((prev) => ({ ...prev, bodyShape: selected || [] }));
        setErrors((prevData) => ({ ...prevData, bodyShape: null }));
    };
    //-----------handle-StyleIdentity-Change-------------------
    const handleStyleIdentityChange = (selected) => {
        setSelectedOptions((prev) => ({ ...prev, styleIdentity: selected || [] }));
        setErrors((prevData) => ({ ...prevData, styleIdentity: null }));
    };
    //-----------handle-Flaunt-Parts-Change------------------
    const handleFlauntPartsChange = (selected) => {
        setSelectedOptions((prev) => ({ ...prev, flauntParts: selected || [] }));
        setErrors((prevData) => ({ ...prevData, flauntParts: null }));
    };
    //-----------handle-Downplay-Parts-Change------------------
    const handleDownplayPartsChange = (selected) => {
        setSelectedOptions((prev) => ({ ...prev, downplayParts: selected || [] }));
        setErrors((prevData) => ({ ...prevData, downplayParts: null }));
    };
    //-----------handle-Occasion-Name-Change------------------
    const handleOccasionNameChange = (selected) => {
        setSelectedOptions((prev) => ({ ...prev, occasionName: selected || [] }));
        setErrors((prevData) => ({ ...prevData, occasionName: null }));
    };
    //-----------handle-Available-Sizes-Change------------------
    const handleAvailableSizesChange = (selected) => {
        setSelectedOptions((prev) => ({ ...prev, availableSizes: selected || [] }));
        setErrors((prevData) => ({ ...prevData, availableSizes: null }));
    };
    // //-------------handle-input-change-------------------
    // const handleInputChange = (e) => {
    //     const { name, value } = e.target;

    //     if (name === "category") {
    //         console.log("name have category", name);
    //         if (value === "Shoes") {
    //             setSizeType("shoes");
    //             setShowSize(false);
    //         } else if (
    //             ["Tops", "Bottoms", "Outerwear", "Jumpsuits", "Dresses"].includes(value)
    //         ) {
    //             setSizeType("clothes");
    //             setShowSize(false);
    //         } else if (["Accessories", "Jewelry"].includes(value)) {
    //             setShowSize(true);
    //         }
    //         sizeListHandler();
    //     }
    //     setSelectedOptions((prevData) => ({ ...prevData, [name]: value }));
    //     setErrors((prevData) => ({ ...prevData, [name]: null }));
    // };

    return (
        <div className="add_model">
            <div className="form_field">
                <label className="label">
                    Palette Name
                    {/* <Star /> */}
                </label>
                <MultiSelect
                    className="w-100"
                    options={paletteOptions}
                    value={selectedOptions?.paletteName}
                    onChange={handlePaletteOptions}
                    overrideStrings={{
                        selectSomeItems: "Select palette name",
                    }}
                />
                {/* {errors && <div className="text-danger">{errors.paletteName}</div>} */}
            </div>
            {/* -----------Body-Shape------------- */}
            <div className="form_field_wrap">
                <div className="form_field">
                    <label className="label">Body Shape</label>
                    <MultiSelect
                        className="w-100"
                        options={bodyShapeArray}
                        value={selectedOptions?.bodyShape}
                        onChange={handleBodyShapeChange}
                        overrideStrings={{
                            selectSomeItems: "Select body shape",
                        }}
                    />
                </div>
                {/* -----------Style-Identity------------- */}
                <div className="form_field">
                    <label className="label">Style Identity</label>
                    <MultiSelect
                        className="w-100"
                        options={styleIdentityArray}
                        value={selectedOptions?.styleIdentity}
                        onChange={handleStyleIdentityChange}
                        overrideStrings={{
                            selectSomeItems: "Select style identity",
                        }}
                    />
                    {/* {errors && <div className="text-danger">{errors.styleIdentity}</div>} */}
                </div>
            </div>

            {/* ----------- Flaunt-Parts------------- */}
            <div className="form_field_wrap">
                <div className="form_field">
                    <label className="label">
                        Flaunt Parts
                        {/* <Star /> */}
                    </label>
                    <MultiSelect
                        className="w-100"
                        options={downplayArray}
                        value={selectedOptions?.flauntParts}
                        onChange={handleFlauntPartsChange}
                        overrideStrings={{
                            selectSomeItems: "Select flaunt parts",
                        }}
                    />
                    {/* {errors && <div className="text-danger">{errors.flauntParts}</div>} */}
                </div>
                {/* -----------Downplay-Parts------------- */}
                <div className="form_field">
                    <label className="label">
                        Downplay Parts
                        {/* <Star /> */}
                    </label>
                    <MultiSelect
                        className="w-100"
                        options={downplayArray}
                        value={selectedOptions?.downplayParts}
                        onChange={handleDownplayPartsChange}
                        overrideStrings={{
                            selectSomeItems: "Select downplay parts",
                        }}
                    />
                    {/* {errors && <div className="text-danger">{errors.downplayParts}</div>} */}
                </div>
            </div>


        </div>
    )
}

export default CommonForm